module.exports = __webpack_public_path__ + "img/honor1.2a61d246.png";